import { GAME_TYPE, GAME_VERSION, getStaticBaseUrl } from './getStaticBaseUrl';

/**
 * Sets the paths for dynamic chunks based on the static base URL and game version.
 * This function should be called in the entry point of the application (index.tsx) to establish proper chunks loading when app use versioned deployements approach.
 * @example import '@pp/core/src/utils/setDynamicPublicPath';
 * @returns {void}
 */

const setDynamicPublicPath = (): void => {
  if (!GAME_VERSION || !GAME_TYPE) return;
  const { base } = getStaticBaseUrl();
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  __webpack_public_path__ = `${base}/apps/${GAME_TYPE}/${GAME_VERSION}/`;
};

setDynamicPublicPath();
